/**
 * Server name to the tool name the LLM sees. Shared because the save-time uniqueness check and the
 * runtime tool name must agree; if they drift, a server saves cleanly and then fails to load.
 */
function toMcpToolNameSlug(value) {
  return String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '');
}

const MCP_AGENT_NAME_PREFIX = 'mcp_';

function buildMcpAgentName(nameOrSlug) {
  return `${MCP_AGENT_NAME_PREFIX}${toMcpToolNameSlug(nameOrSlug)}`;
}

module.exports = { toMcpToolNameSlug, buildMcpAgentName, MCP_AGENT_NAME_PREFIX };
